/**
 * Snipetell Theme JS – Mobile menu + Hero slideshow
 */
document.addEventListener('DOMContentLoaded', () => {
  // ===== Logo typewriter: type → erase → bounce → erase → loop =====
  const typeEl = document.querySelector('[data-typewriter]');
  if (typeEl) {
    const textTarget = typeEl.querySelector('.logo-typewriter__text');
    const fullText = typeEl.dataset.text || 'Snipetell';
    // Reserve exact width so search bar never shifts
    typeEl.style.width = fullText.length + 1 + 'ch';
    typeEl.style.minWidth = typeEl.style.width;
    typeEl.style.maxWidth = typeEl.style.width;
    // 1.5x slower than previous timings
    const typeSpeed = 180;
    const eraseSpeed = 105;
    const holdTyped = 1800;
    const holdErased = 600;
    const holdBounce = 3300;

    let i = 0;
    // type | holdTyped | erase | holdErased | bounce | holdBounce | eraseAfterBounce
    let mode = 'type';

    function tick() {
      if (!textTarget) return;

      if (mode === 'type') {
        i += 1;
        textTarget.textContent = fullText.slice(0, i);
        typeEl.classList.remove('is-bounce');
        if (i >= fullText.length) {
          mode = 'holdTyped';
          setTimeout(tick, holdTyped);
        } else {
          setTimeout(tick, typeSpeed);
        }
        return;
      }

      if (mode === 'holdTyped') {
        mode = 'erase';
        setTimeout(tick, 0);
        return;
      }

      if (mode === 'erase' || mode === 'eraseAfterBounce') {
        i -= 1;
        textTarget.textContent = fullText.slice(0, Math.max(0, i));
        typeEl.classList.remove('is-bounce');
        if (i <= 0) {
          if (mode === 'eraseAfterBounce') {
            // Finished post-bounce erase → restart typing
            mode = 'type';
            setTimeout(tick, holdErased);
          } else {
            mode = 'holdErased';
            setTimeout(tick, holdErased);
          }
        } else {
          setTimeout(tick, eraseSpeed);
        }
        return;
      }

      if (mode === 'holdErased') {
        mode = 'bounce';
        i = fullText.length;
        textTarget.textContent = fullText;
        typeEl.classList.remove('is-bounce');
        void typeEl.offsetWidth; // reflow so bounce can replay
        typeEl.classList.add('is-bounce');
        setTimeout(tick, holdBounce);
        return;
      }

      if (mode === 'bounce') {
        mode = 'holdBounce';
        setTimeout(tick, 0);
        return;
      }

      if (mode === 'holdBounce') {
        // After bounce: erase backward, then loop
        typeEl.classList.remove('is-bounce');
        mode = 'eraseAfterBounce';
        setTimeout(tick, 200);
      }
    }

    tick();
  }

  // ===== Account dropdown (Sign In menu) =====
  document.querySelectorAll('[data-account-dropdown]').forEach(wrap => {
    const toggle = wrap.querySelector('[data-account-toggle]');
    const menu = wrap.querySelector('[data-account-menu]');
    if (!toggle || !menu) return;

    function open() {
      menu.hidden = false;
      wrap.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
    }
    function close() {
      menu.hidden = true;
      wrap.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
    }

    toggle.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (menu.hidden) open(); else close();
    });

    document.addEventListener('click', (e) => {
      if (!wrap.contains(e.target)) close();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') close();
    });
  });

  // ===== Custom search category dropdown =====

  document.querySelectorAll('[data-search-cat]').forEach(wrap => {
    const toggle = wrap.querySelector('[data-search-cat-toggle]');
    const menu = wrap.querySelector('[data-search-cat-menu]');
    const label = wrap.querySelector('[data-search-cat-label]');
    const hidden = wrap.querySelector('[data-search-cat-value]');
    if (!toggle || !menu) return;

    function open() {
      menu.hidden = false;
      wrap.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
    }
    function close() {
      menu.hidden = true;
      wrap.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
    }

    toggle.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (menu.hidden) open(); else close();
    });

    menu.querySelectorAll('.search-cat__option').forEach(opt => {
      opt.addEventListener('click', (e) => {
        e.preventDefault();
        const value = opt.getAttribute('data-value') || '';
        const url = opt.getAttribute('data-url') || '';
        const text = opt.querySelector('span:not(.search-cat__option-icon):not(.search-cat__count)');
        if (hidden) {
          hidden.value = value;
          hidden.dataset.url = url;
        }
        if (label) label.textContent = text ? text.textContent.trim() : 'All Categories';
        menu.querySelectorAll('.search-cat__option').forEach(o => o.classList.remove('is-active'));
        opt.classList.add('is-active');
        close();
      });
    });

    const form = wrap.closest('form');
    if (form) {
      form.addEventListener('submit', (e) => {
        const q = form.querySelector('input[name="q"]');
        const query = q ? q.value.trim() : '';
        const catUrl = hidden && hidden.dataset.url ? hidden.dataset.url : '';
        const catVal = hidden ? hidden.value : '';
        // If a specific category is chosen and there is a query, still use site search (type=product)
        // If category chosen with empty query, go to that collection page
        if (catVal && catUrl && !query) {
          e.preventDefault();
          window.location.href = catUrl;
        }
      });
    }

    document.addEventListener('click', (e) => {
      if (!wrap.contains(e.target)) close();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') close();
    });
  });

  // Wishlist toggle (visual only)

  document.querySelectorAll('.wishlist-btn').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      btn.classList.toggle('active');
    });
  });

  // ===== Mobile navigation drawer =====
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const mobileNav = document.getElementById('mobile-nav');
  const overlay = document.querySelector('[data-nav-overlay]');
  const closeBtn = document.querySelector('[data-nav-close]');

  function openMenu() {
    if (!mobileNav) return;
    mobileNav.classList.add('open');
    mobileNav.setAttribute('aria-hidden', 'false');
    if (overlay) {
      overlay.classList.add('open');
      overlay.setAttribute('aria-hidden', 'false');
    }
    document.body.classList.add('menu-open');
    if (menuToggle) menuToggle.setAttribute('aria-expanded', 'true');
  }

  function closeMenu() {
    if (!mobileNav) return;
    mobileNav.classList.remove('open');
    mobileNav.setAttribute('aria-hidden', 'true');
    if (overlay) {
      overlay.classList.remove('open');
      overlay.setAttribute('aria-hidden', 'true');
    }
    document.body.classList.remove('menu-open');
    if (menuToggle) menuToggle.setAttribute('aria-expanded', 'false');
  }

  if (menuToggle) {
    menuToggle.addEventListener('click', (e) => {
      e.preventDefault();
      if (mobileNav && mobileNav.classList.contains('open')) {
        closeMenu();
      } else {
        openMenu();
      }
    });
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', (e) => {
      e.preventDefault();
      closeMenu();
    });
  }

  if (overlay) {
    overlay.addEventListener('click', closeMenu);
  }

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && mobileNav && mobileNav.classList.contains('open')) {
      closeMenu();
    }
  });

  if (mobileNav) {
    mobileNav.querySelectorAll('a.nav-item').forEach(link => {
      link.addEventListener('click', () => {
        setTimeout(closeMenu, 150);
      });
    });
  }

  // ===== Hero Slideshow =====
  const slideshow = document.querySelector('[data-hero-slideshow]');
  if (slideshow) {
    const slides = slideshow.querySelectorAll('.hero-slide');
    const dots = slideshow.querySelectorAll('[data-dot-index]');
    const prevBtn = slideshow.querySelector('[data-hero-prev]');
    const nextBtn = slideshow.querySelector('[data-hero-next]');
    const autoplay = slideshow.dataset.autoplay === 'true';
    const interval = parseInt(slideshow.dataset.interval, 10) || 5000;

    let current = 0;
    let timer = null;
    const total = slides.length;

    if (total <= 1) {
      if (prevBtn) prevBtn.style.display = 'none';
      if (nextBtn) nextBtn.style.display = 'none';
      const dotsWrap = slideshow.querySelector('[data-hero-dots]');
      if (dotsWrap) dotsWrap.style.display = 'none';
    }

    function goTo(index) {
      if (total === 0) return;
      current = (index + total) % total;

      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === current);
      });

      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === current);
      });
    }

    function next() {
      goTo(current + 1);
    }

    function prev() {
      goTo(current - 1);
    }

    function startAutoplay() {
      if (!autoplay || total <= 1) return;
      stopAutoplay();
      timer = setInterval(next, interval);
    }

    function stopAutoplay() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    if (nextBtn) nextBtn.addEventListener('click', () => { next(); startAutoplay(); });
    if (prevBtn) prevBtn.addEventListener('click', () => { prev(); startAutoplay(); });

    dots.forEach(dot => {
      dot.addEventListener('click', () => {
        const idx = parseInt(dot.dataset.dotIndex, 10);
        goTo(idx);
        startAutoplay();
      });
    });

    // Pause on hover / focus
    slideshow.addEventListener('mouseenter', stopAutoplay);
    slideshow.addEventListener('mouseleave', startAutoplay);
    slideshow.addEventListener('focusin', stopAutoplay);
    slideshow.addEventListener('focusout', startAutoplay);

    // Touch swipe support
    let touchStartX = 0;
    let touchEndX = 0;

    slideshow.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
      stopAutoplay();
    }, { passive: true });

    slideshow.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      const diff = touchStartX - touchEndX;
      if (Math.abs(diff) > 50) {
        if (diff > 0) next();
        else prev();
      }
      startAutoplay();
    }, { passive: true });

    // Init
    goTo(0);
    startAutoplay();
  }

  // ===== Product media gallery (with autoslide) =====
  const gallery = document.querySelector('[data-product-gallery]');
  if (gallery) {
    const mediaItems = gallery.querySelectorAll('.product-gallery__media');
    const thumbs = gallery.querySelectorAll('[data-thumb-index]');
    const autoplay = gallery.dataset.autoplay !== 'false';
    const interval = parseInt(gallery.dataset.interval, 10) || 4000;
    let current = 0;
    let timer = null;
    const total = mediaItems.length;

    function showMedia(index) {
      if (total === 0) return;
      current = (index + total) % total;
      mediaItems.forEach((el, i) => {
        const active = i === current;
        el.classList.toggle('is-active', active);
        if (!active) {
          const video = el.querySelector('video');
          if (video) video.pause();
        }
      });
      thumbs.forEach((t, i) => t.classList.toggle('is-active', i === current));
    }

    function nextMedia() {
      showMedia(current + 1);
    }

    function startGalleryAutoplay() {
      if (!autoplay || total <= 1) return;
      stopGalleryAutoplay();
      timer = setInterval(nextMedia, interval);
    }

    function stopGalleryAutoplay() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        const idx = parseInt(thumb.dataset.thumbIndex, 10);
        showMedia(idx);
        startGalleryAutoplay();
      });
    });

    gallery.addEventListener('mouseenter', stopGalleryAutoplay);
    gallery.addEventListener('mouseleave', startGalleryAutoplay);
    gallery.addEventListener('focusin', stopGalleryAutoplay);
    gallery.addEventListener('focusout', startGalleryAutoplay);

    // Touch swipe
    let touchStartX = 0;
    gallery.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
      stopGalleryAutoplay();
    }, { passive: true });
    gallery.addEventListener('touchend', (e) => {
      const diff = touchStartX - e.changedTouches[0].screenX;
      if (Math.abs(diff) > 40) {
        if (diff > 0) nextMedia();
        else showMedia(current - 1);
      }
      startGalleryAutoplay();
    }, { passive: true });

    showMedia(0);
    startGalleryAutoplay();
  }

  // ===== Product variant selection (basic) =====
  const productJsonEl = document.querySelector('[data-product-json]');
  if (productJsonEl) {
    let productData = null;
    try {
      productData = JSON.parse(productJsonEl.textContent);
    } catch (e) {}

    const form = document.getElementById('product-form') || document.querySelector('form[action*="/cart/add"]');
    const variantInput = document.querySelector('[data-variant-id]');
    const priceEl = document.querySelector('[data-product-price]');
    const compareEl = document.querySelector('[data-compare-price]');
    const addBtn = document.querySelector('.product-add-to-cart');
    const optionSelects = document.querySelectorAll('[data-option-index]');

    function getSelectedOptions() {
      const opts = [];
      optionSelects.forEach(sel => {
        opts[parseInt(sel.dataset.optionIndex, 10)] = sel.value;
      });
      return opts;
    }

    function findVariant(options) {
      if (!productData || !productData.variants) return null;
      return productData.variants.find(v => {
        return v.options.every((opt, i) => opt === options[i]);
      });
    }

    function formatMoney(cents) {
      // Simple fallback; Shopify themes usually have money format helpers
      try {
        return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' });
      } catch (e) {
        return '$' + (cents / 100).toFixed(2);
      }
    }

    function updateVariant() {
      if (!productData) return;
      const options = getSelectedOptions();
      const variant = findVariant(options);
      if (!variant) return;

      if (variantInput) variantInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
      }

      // Switch to variant featured media if present
      if (variant.featured_media && gallery) {
        const mediaEl = gallery.querySelector('[data-media-id="' + variant.featured_media.id + '"]');
        if (mediaEl) {
          const idx = parseInt(mediaEl.dataset.mediaIndex, 10);
          if (!isNaN(idx)) {
            const mediaItems = gallery.querySelectorAll('.product-gallery__media');
            const thumbs = gallery.querySelectorAll('[data-thumb-index]');
            mediaItems.forEach((el, i) => el.classList.toggle('is-active', i === idx));
            thumbs.forEach((t, i) => t.classList.toggle('is-active', i === idx));
          }
        }
      }
    }

    optionSelects.forEach(sel => {
      sel.addEventListener('change', updateVariant);
    });
  }
});
